import React from 'react';

import { flagStyles } from '../settings';

const SvgGI = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1920px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGI;
